import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export default function FollowUs() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 3 }}>
      <Typography component="h2" variant="h4" sx={{ mb: 3 }}>
        Follow Us on Instagram
      </Typography>
      <Box
        sx={{
          width: '100%',
          maxWidth: 800,
          borderRadius: 2,
          overflow: 'hidden',
        }}
      >
        <iframe src="https://embedsocial.com/api/pro_hashtag/20498d58393f086621c14fdf19b137e76743563c" title="Instagram Feed" width="500" height="800" frameborder="0" marginheight="0" marginwidth="0"></iframe>
      </Box>
    </Box>
  );
}

